<div edsGrid *ngIf="calculatorType === 'taxable-equivalent-yield'">
  <div edsGrid>
    <div class="container">
      <div edsRow edsPadding edsPaddingBottom="md">
        <!-- Tax Yield Calculator -->

        <div edsCol>
          <div>
            <!-- Selection Dropdowns -->
            <div edsRow [edsSpacing]="(isHandheld$ | async) ? 'md' : 'none'">
              <div edsCol [columnNumbers]="{ s: 4, m: 8, l: 3 }">
                <eds-dropdown
                  ariaLabel="Dropdown"
                  id="fedTaxDropDown"
                  edsSpacing="md"
                  name="fedTaxDropDown"
                  [invalid]="fedTaxInvalid"
                  [invalidText]="taxYieldCalculatorFedTaxInvalid"
                  [items]="dropdownTaxRateRange"
                  (dropdownChange)="onFedTaxChange($event)"
                  ><span>{{ fedTaxLabel }} <sup>1</sup></span>
                </eds-dropdown>
              </div>

              <div edsCol [columnNumbers]="{ s: 4, m: 8, l: 2 }">
                <eds-dropdown
                  ariaLabel="Dropdown"
                  id="stateDropDown"
                  name="stateDropDown"
                  edsSpacing="md"
                  [invalid]="stateInvalid"
                  [invalidText]="taxYieldCalculatorStateSelectionInvalid"
                  [label]="stateSelectionLabel"
                  [items]="dropdownStateRange"
                  (dropdownChange)="onStateChange($event)"
                ></eds-dropdown>
              </div>

              <div edsCol [columnNumbers]="{ s: 4, m: 8, l: 3 }">
                <eds-dropdown
                  ariaLabel="Dropdown"
                  id="hypoYieldDropDown"
                  name="hypoYieldDropDown"
                  [label]="hypoYieldLabel"
                  [invalid]="hypoInvalid"
                  [invalidText]="taxYieldCalculatorHypoYieldInvalid"
                  [items]="dropdownHypoRange"
                  (dropdownChange)="onHypoChange($event)"
                ></eds-dropdown>
              </div>
            </div>

            <div edsSpacing="xl">
              <button (click)="calculate()" edsButton="emphasis">
                {{ taxYieldCalculatorCalculateLabel }}
              </button>
            </div>

            <!--  Calculator Text and Result String-->
            <div *ngIf="calculated" edsFlexbox flexWrap="wrap">
              <div>
                <h5 edsSpacing="md" class="income-tax-rates">
                  {{ taxYieldCalculatorResultAPart1 }}
                  <strong> {{ finalValue }}% </strong>
                  {{ taxYieldCalculatorResultAPart2 }}

                  <strong>{{ displayHypotheticalYield }}% </strong>.<sup>1</sup>
                </h5>
              </div>
            </div>

            <!-- Federal Tax rates and Brackets(table) -->
            <div edsRow>
              <div
                edsFlexItem
                flexBasis="auto"
                [style.max-width]="(isHandheld$ | async) ? 'none' : '60%'"
              >
                <div edsSpacing="xl" edsCol>
                  <!--Title  -->

                  <h6 edsPadding edsPaddingBottom="md">
                    <span class="eds-title">{{
                      taxYieldCalculatorTableHeading
                    }}</span
                    ><sup>1</sup>
                  </h6>
                  <div [class.income-tax-table]="isHandheld$ | async">
                    <table>
                      <thead>
                        <tr>
                          <th></th>
                          <th edsPadding edsPaddingAll="sm">24%</th>
                          <th edsPadding edsPaddingAll="sm">32%</th>
                          <th edsPadding edsPaddingAll="sm">35%</th>
                          <th edsPadding edsPaddingAll="sm">37%</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td colspan="4" edsPadding edsPaddingAll="sm">
                            {{ taxYieldTableIncome }}
                          </td>
                        </tr>
                        <tr>
                          <td edsPadding edsPaddingAll="sm">
                            {{ taxYieldTableJointReturn }}
                          </td>
                          <td edsPadding edsPaddingAll="sm">
                            {{
                              taxYieldCalculatorJoint24
                                | currency: "USD":"symbol":"1.0-0"
                            }}– <br />{{
                              taxYieldCalculatorReturn24
                                | currency: "USD":"symbol":"1.0-0"
                            }}
                          </td>
                          <td edsPadding edsPaddingAll="sm">
                            {{
                              taxYieldCalculatorJoint32
                                | currency: "USD":"symbol":"1.0-0"
                            }}– <br />{{
                              taxYieldCalculatorReturn32
                                | currency: "USD":"symbol":"1.0-0"
                            }}
                          </td>
                          <td edsPadding edsPaddingAll="sm">
                            {{
                              taxYieldCalculatorJoint35
                                | currency: "USD":"symbol":"1.0-0"
                            }}– <br />{{
                              taxYieldCalculatorReturn35
                                | currency: "USD":"symbol":"1.0-0"
                            }}
                          </td>
                          <td edsPadding edsPaddingAll="sm">
                            {{
                              taxYieldCalculatorJoint37
                                | currency: "USD":"symbol":"1.0-0"
                            }}+
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div edsGrid *ngIf="calculatorType === 'roth-ira'">
  <div edsgrid>
    <div class="container">
      <div edsRow>
        <!--Roth IRA calculator-->
        <div class="tax-calculator">
          <div *ngIf="rothIraCalculated" #rothIraResult edsSpacing="md">
            <p>{{ rothIraCalulatedHeading }}</p>

            <!-- Result table -->
            <table>
              <tbody>
                <tr>
                  <td edsPadding edsPaddingAll="sm">
                    <strong>{{ rothIraConvertToRoth }}</strong>
                  </td>
                  <td edsPadding edsPaddingAll="sm">
                    <strong>{{ rothIra | currency }}</strong>
                  </td>
                </tr>
                <tr>
                  <td edsPadding edsPaddingAll="sm">
                    <strong>{{ rothIraDontConvertToRoth }}</strong>
                  </td>
                  <td edsPadding edsPaddingAll="sm">
                    <strong>{{ traditionalIra | currency }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>

            <p>{{ rothIraResultHeading }}</p>
            <ul>
              <li>{{ rothIraResultListItem1 }}</li>
              <li>{{ rothIraResultListItem2 }}</li>
              <li>{{ rothIraResultListItem3 }}</li>
              <li>{{ rothIraResultListItem4 }}</li>
            </ul>
          </div>

          <!-- Dropdowns and input fields -->
          <div>
            <!-- Current IRA value -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep1Label }}</label>
                </div>
              </div>

              <div edsRow>
                <div edsCol>
                  <eds-text-input
                    name="IRA-value"
                    type="number"
                    placeholder=""
                    aria-label="inputText"
                    [invalid]="step1Invalid"
                    [invalidText]="rothIraStep1Missing"
                    [hasHelperText]="true"
                    [(value)]="step1Input"
                    (inputTextChange)="setIraStep1($event)"
                  ></eds-text-input>
                </div>
              </div>
            </div>

            <!-- Total amount of non-deductable IRA contribution -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep2Label }}</label>
                  <div class="text-muted">({{ rothIraStep2HelperText }})</div>
                </div>
              </div>

              <div edsRow>
                <div edsCol>
                  <eds-text-input
                    name="IRA-amount"
                    type="number"
                    placeholder=""
                    aria-label="inputText"
                    [hasHelperText]="true"
                    [invalid]="step2Invalid"
                    [invalidText]="rothIraStep2Missing"
                    [(value)]="step2Input"
                    (inputTextChange)="setIraStep2($event)"
                  ></eds-text-input>
                </div>
              </div>
            </div>

            <!-- Annual rate of return expected before retirement -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep3Label }}</label>
                  <div class="text-muted">
                    ({{ rothIraStep3HelperText }}<sup>1</sup>)
                  </div>
                </div>
              </div>

              <div edsRow>
                <div
                  edsCol
                  [columnNumbers]="{ s: 4, m: 3, l: 4 }"
                  class="no-padding"
                >
                  <eds-dropdown
                    ariaLabel="Dropdown"
                    [id]="'AnnualRateBeforeRetirementDD'"
                    #step3DropDown
                    [titleText]="rothIraPercentageValue"
                    [invalid]="step3Invalid"
                    [invalidText]="rothIraStep3Missing"
                    (dropdownChange)="setIraStep3($event)"
                    [items]="rothIraRetirementRates"
                  ></eds-dropdown>
                </div>
              </div>
            </div>

            <!-- Annual rate of return expected during retirement -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep4Label }}</label>
                  <div class="text-muted">
                    ({{ rothIraStep4HelperText }}<sup>1</sup>)
                  </div>
                </div>
              </div>

              <div edsRow>
                <div
                  edsCol
                  [columnNumbers]="{ s: 4, m: 3, l: 4 }"
                  class="no-padding"
                >
                  <eds-dropdown
                    ariaLabel="Dropdown"
                    [id]="'AnnualRateDuringRetirementDD'"
                    [invalid]="step4Invalid"
                    [invalidText]="rothIraStep4Missing"
                    #step4DropDown
                    [titleText]="rothIraPercentageValue"
                    (dropdownChange)="setIraStep4($event)"
                    [items]="rothIraDuringRetirementRates"
                  ></eds-dropdown>
                </div>
              </div>
            </div>

            <!-- Number of years planned to save until retirement -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep5Label }}</label>
                </div>
              </div>

              <div edsRow>
                <div
                  edsCol
                  [columnNumbers]="{ s: 4, m: 3, l: 4 }"
                  class="no-padding"
                >
                  <eds-dropdown
                    ariaLabel="Dropdown"
                    [id]="'NoOfYrUntilRetirementDD'"
                    #step5DropDown
                    [titleText]="rothIraYearsLabel"
                    [invalid]="step5Invalid"
                    [invalidText]="rothIraStep5Missing"
                    (dropdownChange)="setIraStep5($event)"
                    [items]="rothIraSaveUntilRetirement"
                  ></eds-dropdown>
                </div>
              </div>
            </div>

            <!-- Number of years planned on taking distribution after retirement -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep6Label }}</label>
                </div>
              </div>

              <div edsRow>
                <div
                  edsCol
                  [columnNumbers]="{ s: 4, m: 3, l: 4 }"
                  class="no-padding"
                >
                  <eds-dropdown
                    ariaLabel="Dropdown"
                    [id]="'NoOfYrAfterRetirementDD'"
                    #step6DropDown
                    [titleText]="rothIraYearsLabel"
                    [invalid]="step6Invalid"
                    [invalidText]="rothIraStep6Missing"
                    (dropdownChange)="setIraStep6($event)"
                    [items]="rothIraSaveAfterRetirement"
                  ></eds-dropdown>
                </div>
              </div>
            </div>

            <!-- Federal Income tax rate prior to retirement -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep7Label }}</label>
                </div>
              </div>

              <div edsRow>
                <div
                  edsCol
                  [columnNumbers]="{ s: 4, m: 3, l: 4 }"
                  class="no-padding"
                >
                  <eds-dropdown
                    #step7DropDown
                    ariaLabel="Dropdown"
                    [id]="'ITRPiorRetirementDD'"
                    [titleText]="rothIraPercentageValue"
                    [invalid]="step7Invalid"
                    [invalidText]="rothIraStep7Missing"
                    (dropdownChange)="setIraStep7($event)"
                    [items]="rothIraFedTaxRate"
                  ></eds-dropdown>
                </div>
              </div>
            </div>

            <!-- Anticipated income tax rate during retirement -->
            <div edsPadding edsPaddingBottom="lg">
              <div edsRow>
                <div edsCol>
                  <label>{{ rothIraStep8Label }}</label>
                </div>
              </div>

              <div edsRow>
                <div
                  edsCol
                  [columnNumbers]="{ s: 4, m: 3, l: 4 }"
                  class="no-padding"
                >
                  <eds-dropdown
                    #step8DropDown
                    ariaLabel="Dropdown"
                    [id]="'ITRDuringRetirementDD'"
                    [titleText]="rothIraPercentageValue"
                    [invalid]="step8Invalid"
                    [invalidText]="rothIraStep8Missing"
                    (dropdownChange)="setIraStep8($event)"
                    [items]="rothIraFedTaxRateDuringRetirement"
                  ></eds-dropdown>
                </div>
              </div>
            </div>

            <!-- Clear and Calculate buttons -->
            <div edsRow>
              <div edsCol>
                <button edsButton="secondary" (click)="reset()">
                  {{ rothIraClearLabel }}
                </button>

                <button edsButton="primary" (click)="calculateRothIRA()">
                  {{ rothIraCalculateLabel }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Make a Contribution Calculator-->

<div edsGrid *ngIf="calculatorType === 'monthly-contribution'">
  <div class="container">
    <div edsRow>
      <!--    Column1-->
      <div
        edsCol
        [columnNumbers]="{ s: 4, m: 3, l: 4 }"
        edsPadding
        edsPaddingRight="lg"
      >
        <div>
          <eds-title edsPadding edsPaddingLeft="xs" [size]="'h6'">
            {{ monthlyContributionYearsLeft }}
          </eds-title>
          <eds-progress-slider
            edsSpacing="md"
            edsPadding
            edsPaddingLeft="xs"
            [min]="1"
            minLabel="1"
            [max]="18"
            maxLabel="18"
            ariaMinLabel="Add"
            ariaMaxLabel="Subtract"
            [value]="monthlyContriYears"
            [multiplier]="1"
            [tickMarksCount]="9"
            (valueChanged)="onYearValueChanged($event)"
          ></eds-progress-slider>

          <eds-title edsPadding edsPaddingLeft="xs" [size]="'h6'">
            {{ monthlyContributionMonthlyContribution }}
          </eds-title>
          <eds-progress-slider
            edsSpacing="md"
            edsPadding
            edsPaddingLeft="xs"
            [multiplier]="25"
            [min]="25"
            minLabel="25"
            [max]="750"
            maxLabel="750"
            ariaMinLabel="Add"
            ariaMaxLabel="Subtract"
            [value]="monthlyContriAmount"
            [tickMarksCount]="15"
            (valueChanged)="onAmountValueChanged($event)"
          ></eds-progress-slider>

          <eds-title
            edsPadding
            edsSpacing="md"
            edsPaddingLeft="xs"
            [size]="'h6'"
          >
            {{ monthlyContributionRateOfReturn }}
          </eds-title>

          <eds-progress-stepper
            edsSpacing="xxl"
            [stepInfo]="monthlyContriStepInfo"
            [current]="monthlyContriCurrentStep"
            (stepSelected)="onRateValueChanged($event)"
          ></eds-progress-stepper>

          <div edsFlexbox [style.justify-content]="'flex-end'">
            <button edsButton="emphasis" (click)="calculateMonthlyContri()">
              {{ monthlyContributionCalculateLabel }}
            </button>
          </div>
        </div>
      </div>

      <!--  Column2-->
      <div
        edsCol
        edsPadding
        [columnNumbers]="{ s: 4, m: 3, l: 4 }"
        edsPaddingLeft="lg"
        [ngClass]="{ 'grey-border-left': (isHandheld$ | async) === false }"
      >
        <div>
          <div
            edsSpacing="md"
            edsFlexItem
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-between"
          >
            {{ monthlyContributionResult1 }}
            <strong> {{ monthlyContriAmount | currency }} </strong>
            {{ monthlyContributionResult2 }}
            <strong> {{ monthlyContriRate }}% </strong>
            {{ monthlyContributionResult3 }}
            <strong> {{ monthlyContriYears }} years </strong>
            {{ monthlyContributionResult4 }}
          </div>
          <h1
            edsSpacing="md"
            edsFlexbox
            flexWrap="wrap"
            alignItems="center"
            justifyContent="center"
          >
            {{ monthlyContriFutureValue | currency: "USD":"symbol":"1.0-0" }}
          </h1>

          <div edsSpacing="md">
            <strong>{{ monthlyContributionContributeMore }}</strong>
          </div>
          <div edsSpacing="md">
            {{ monthlyContributionChartHeading }}
          </div>

          <eds-title [size]="'h6'" edsSpacing="md">
            {{ monthlyContributionHypoSavings1 }}
            {{ monthlyContriYears }} {{ monthlyContributionHypoSavings2 }}
          </eds-title>

          <div
            edsPadding
            edsPaddingLeft="xl"
            edsFlexbox
            alignItems="center"
            justifyContent="flex-start"
          >
            <span class="series1"></span>
            <span edsPadding edsPaddingLeft="xs" edsPaddingRight="md">{{
              monthlyContriAmount | currency: "USD":"symbol":"1.0-0"
            }}</span>
            <span class="series2"></span>
            <span edsPadding edsPaddingLeft="xs" edsPaddingRight="md">{{
              monthlyContriAmount + 50 | currency: "USD":"symbol":"1.0-0"
            }}</span>
            <span class="series3"></span>
            <span edsPadding edsPaddingLeft="xs" edsPaddingRight="md">{{
              monthlyContriAmount + 100 | currency: "USD":"symbol":"1.0-0"
            }}</span>
          </div>
        </div>
        <ng-container *ngIf="highcharts && chartOptions">
          <highcharts-chart
            [Highcharts]="highcharts"
            [options]="chartOptions"
            [(update)]="updateChart"
            style="width: 100%; height: 300px; display: block"
          ></highcharts-chart>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!--Envelope Table Calculator-->
<div edsGrid *ngIf="calculatorType === 'envelope-table'">
  <div class="container">
    <div edsRow edsFlexbox justifyContent="flex-end">
      <button
        edsButton="emphasis"
        (click)="toggleRevealAll()"
        size="small"
        edsFlexItem
      >
        {{ revealShowAllText }}
      </button>
      <table class="calculator-table">
        <thead>
          <tr>
            <th
              edsPadding
              edsPaddingTop="xs"
              edsPaddingBottom="xs"
              *ngFor="let month of months"
            >
              {{ month }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let colData of colsData">
            <td edsPadding edsPaddingTop="xs" edsPaddingBottom="xs">
              <strong>{{ colData.year }}</strong>
            </td>

            <td
              edsPadding
              edsPaddingTop="xs"
              edsPaddingBottom="xs"
              *ngFor="let data of colData.data"
            >
              <div
                *ngIf="!data.showImage"
                class="calculator-table__envelope-text"
              >
                {{ data.amount | currency: "USD":"symbol":"1.0-0" }}
              </div>
              <eds-icon
                class="calculator-table__envelope-icon"
                *ngIf="data.showImage"
                (click)="data.showImage = false"
                type="mail"
              ></eds-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
